import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Option } from '@vendasta/forms';
import { Observable } from 'rxjs';
import { SalespersonMultiSelectStoreService } from './salesperson-multi-select.store.service';
import { map, take } from 'rxjs/operators';
import { UntypedFormControl } from '@angular/forms';
import { SubscriptionList } from '@vendasta/rx-utils';
import { SalespersonOption } from '../filter-options/salesperson-option.model';

@Component({
  templateUrl: './salesperson-multi-select.component.html',
  styleUrls: ['./salesperson-multi-select.component.scss'],
  standalone: false,
})
export class SalespersonMultiSelectComponent implements OnInit, OnDestroy {
  selectableSalespeople$: Observable<Option[]>;
  readonly formControl: UntypedFormControl = new UntypedFormControl([], []);
  private readonly subscriptions = SubscriptionList.new();

  constructor(
    public dialogRef: MatDialogRef<SalespersonMultiSelectComponent>,
    private readonly store: SalespersonMultiSelectStoreService,
  ) {}

  ngOnInit(): void {
    this.selectableSalespeople$ = this.store.selectableSalespeople$.pipe(
      map((sp: SalespersonOption[]): Option[] => sp.map((s) => ({ name: s.fullName, value: s.toOptionValue() }))),
      map((sp) => {
        // remove duplicates
        const options = new Set();
        return sp.filter((obj) => {
          if (!options.has(obj.name)) {
            options.add(obj.name);
            return true;
          }
          return false;
        });
      }),
    );
    // set the selected value if the store has a previous value
    this.subscriptions.add(
      this.store.selectedSalespeople$.pipe(
        take(1),
        map((sp: SalespersonOption[]): string[] => sp.map((s) => s.toOptionValue())),
      ),
      (sp) => this.formControl.setValue(sp),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.destroy();
  }

  cancel(): void {
    this.dialogRef.close();
  }

  save(): void {
    this.store.setSelectedSalespeople(this.formControl.value);
    this.dialogRef.close();
  }
}
